import {Switch, Route} from "react-router-dom"
import Home from "./Pages/Index";
import Blogs from "./Pages/Blogs";
import BlogView from "./Pages/BlogView";
import Careers from "./Pages/Careers";
import ScrollToTop from "./ScrollToTop";
import React from "react";
import Faqs from "./Pages/Faqs";
import TripCost from "./Pages/TripCost";
import Passengers from "./Pages/Passengers";
import CarOwners from "./Pages/CarOwners";
import NotFound from "./Pages/NotFound";
import Terms from "./Pages/terms";
import Privacy from "./Pages/privacy";
import Cookie from "./Pages/cookie";

const Router = () => {
    return (
        <div>
            <ScrollToTop>
                <Switch>
                    <Route path="/" exact component={Home} />
                    <Route path="/passengers" exact component={Passengers} />
                    <Route path="/car-owners" exact component={CarOwners} />
                    <Route path="/trip-cost" exact component={TripCost} />
                    <Route path="/careers" exact component={Careers} />
                    <Route path="/faqs" exact component={Faqs} />
                    <Route path="/terms" exact component={Terms} />
                    <Route path="/privacy" exact component={Privacy} />
                    <Route path="/cookie-policy" exact component={Cookie} />
                    <Route path="/blogs" exact component={Blogs} />
                    <Route path="/blogs/:id" exact component={BlogView} />
                    <Route path="/*" exact component={NotFound} />
                </Switch>
            </ScrollToTop>
        </div>
    )
}

export default Router